// extracted by mini-css-extract-plugin
export var card = "CountdownTimer-module--card--b2906";
export var cardWrapper = "CountdownTimer-module--cardWrapper--9e85b";
export var wrapper = "CountdownTimer-module--wrapper--83f78";